import { render, staticRenderFns } from "./VmDistrict.vue?vue&type=template&id=03ec09ba"
import script from "./VmDistrict.vue?vue&type=script&lang=js"
export * from "./VmDistrict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports